"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

/**
 * Body of a card. Allows optional title, subtitle, and description props, and custom children displayed underneath.
 */
var CardBody =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2["default"])(CardBody, _React$Component);

  function CardBody() {
    (0, _classCallCheck2["default"])(this, CardBody);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(CardBody).apply(this, arguments));
  }

  (0, _createClass2["default"])(CardBody, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          subtitle = _this$props.subtitle,
          description = _this$props.description,
          children = _this$props.children;
      var _this$context = this.context,
          cardVariant = _this$context.cardVariant,
          actionMenu = _this$context.actionMenu;
      var subtitleWrapper = subtitle ? _react["default"].createElement("div", {
        className: "spectrum-Card-subtitle"
      }, subtitle) : null;
      var descriptionWrapper = description ? _react["default"].createElement("div", {
        className: "spectrum-Card-description"
      }, description) : null;
      return _react["default"].createElement("div", {
        className: "spectrum-Card-body"
      }, title || actionMenu ? _react["default"].createElement("div", {
        className: "spectrum-Card-header"
      }, title ? _react["default"].createElement("div", {
        className: "spectrum-Card-title"
      }, title) : null, cardVariant === 'gallery' && subtitleWrapper, cardVariant === 'gallery' && descriptionWrapper, actionMenu ? _react["default"].createElement("div", {
        className: "spectrum-Card-actionButton"
      }, _react["default"].cloneElement(actionMenu, {
        alignRight: true
      })) : null) : null, cardVariant !== 'gallery' && (subtitle || description) ? _react["default"].createElement("div", {
        className: "spectrum-Card-content"
      }, subtitleWrapper, descriptionWrapper) : null, children);
    }
  }]);
  return CardBody;
}(_react["default"].Component);

exports["default"] = CardBody;
(0, _defineProperty2["default"])(CardBody, "displayName", 'CardBody');
(0, _defineProperty2["default"])(CardBody, "propTypes", {
  /** Title for the card */
  title: _propTypes["default"].string,

  /** Subtitle for the card, e.g. file type, displayed in capitalized style */
  subtitle: _propTypes["default"].string,

  /** Description for the card */
  description: _propTypes["default"].string
});
(0, _defineProperty2["default"])(CardBody, "contextTypes", {
  cardVariant: _propTypes["default"].string,
  actionMenu: _propTypes["default"].element
});